<ion-footer class="footer">
  <ion-fab horizontal="center" class="footerFab">
    <ion-fab-button [routerLink]="'/admin'" color="secondary">
      <ion-icon name="cog"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-footer>
